import type { ThemeVariables } from './AbstractTheme';

export const themeVariables: ThemeVariables = {
  borderRadius: {
    full: {
      desktop: '--theme-border-radius-full-desktop',
      mobile: '--theme-border-radius-full-mobile',
    },
    md: {
      desktop: '--theme-border-radius-md-desktop',
      mobile: '--theme-border-radius-md-mobile',
    },
  },
  colors: {
    content: {
      brand: '--theme-color-content-brand',
      disabled: '--theme-color-content-disabled',
      inverse: '--theme-color-content-inverse',
      negative: '--theme-color-content-negative',
      notice: '--theme-color-content-notice',
      positive: '--theme-color-content-positive',
      primary: '--theme-color-content-primary',
      secondary: '--theme-color-content-secondary',
      tertiary: '--theme-color-content-tertiary',
    },
    interaction: {
      link: {
        default: '--theme-color-interaction-link-default',
        focusVisible: '--theme-color-interaction-link-focus-visible',
        hover: '--theme-color-interaction-link-hover',
        pressed: '--theme-color-interaction-link-pressed',
        visited: '--theme-color-interaction-link-visited',
      },
    },
    stroke: {
      brand: '--theme-color-stroke-brand',
      default: '--theme-color-stroke-default',
      disabled: '--theme-color-stroke-disabled',
      focus: '--theme-color-stroke-focus',
      negative: '--theme-color-stroke-negative',
      notice: '--theme-color-stroke-notice',
      positive: '--theme-color-stroke-positive',
    },
    surface: {
      brand: '--theme-color-surface-brand',
      default: '--theme-color-surface-default',
      disabled: '--theme-color-surface-disabled',
      inverse: '--theme-color-surface-inverse',
      negative: '--theme-color-surface-negative',
      notice: '--theme-color-surface-notice',
      overlay: '--theme-color-surface-overlay',
      positive: '--theme-color-surface-positive',
    },
  },
  spacing: {
    lg: '--theme-spacing-lg',
    md: '--theme-spacing-md',
    sm: '--theme-spacing-sm',
    xl: '--theme-spacing-xl',
    xs: '--theme-spacing-xs',
    xxl: '--theme-spacing-xxl',
  },
  strokeWidth: '--theme-stroke-width',
  typography: {
    body: {
      fontFamily: '--theme-typography-body-font-family',
      fontWeight: '--theme-typography-body-font-weight',
      letterSpacing: '--theme-typography-body-letter-spacing',
      sizes: {
        sm: {
          fontSize: '--theme-type-scale-body-sm-font-size',
          lineHeight: '--theme-type-scale-body-sm-line-height',
        },
        md: {
          fontSize: '--theme-type-scale-body-md-font-size',
          lineHeight: '--theme-type-scale-body-md-line-height',
        },
        lg: {
          fontSize: '--theme-type-scale-body-lg-font-size',
          lineHeight: '--theme-type-scale-body-lg-line-height',
        },
      },
    },
    heading: {
      fontFamily: '--theme-typography-heading-font-family',
      fontWeight: '--theme-typography-heading-font-weight',
      letterSpacing: '--theme-typography-heading-letter-spacing',
      sizes: {
        xs: {
          fontSize: '--theme-type-scale-heading-xs-font-size',
          lineHeight: '--theme-type-scale-heading-xs-line-height',
        },
        sm: {
          fontSize: '--theme-type-scale-heading-sm-font-size',
          lineHeight: '--theme-type-scale-heading-sm-line-height',
        },
        md: {
          fontSize: '--theme-type-scale-heading-md-font-size',
          lineHeight: '--theme-type-scale-heading-md-line-height',
        },
        lg: {
          fontSize: '--theme-type-scale-heading-lg-font-size',
          lineHeight: '--theme-type-scale-heading-lg-line-height',
        },
        xl: {
          fontSize: '--theme-type-scale-heading-xl-font-size',
          lineHeight: '--theme-type-scale-heading-xl-line-height',
        },
        xxl: {
          fontSize: '--theme-type-scale-heading-xxl-font-size',
          lineHeight: '--theme-type-scale-heading-xxl-line-height',
        },
      },
    },
  },
};
